import React from 'react';

function Twitter() {
    return (
        <div className='social'>

            <h1>twitter page</h1>
        </div>
    )
}

export default Twitter
